import { Icons, EmptyState, Heading, Paragraph } from "@ir/ui";

const NoDeduction: React.FC<{ error: string }> = ({ error }) => {
  return (
    <EmptyState
      className="bg-white border-1 border-color-grey-25 px-4 py-5 m-2"
      icon={Icons.Settings}
      title={
        <Heading level={6} className="text-grey-700 font-bold mt-3">
          Error fetching remittances
        </Heading>
      }
      description={<Paragraph className="text-grey-500 font-regular mb-0">{error}</Paragraph>}
    />
  );
};

export default NoDeduction;
